import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import {SendPodEmailResult, sendPodEmailService } from "@WhiteCap/Store/Service/PODService";

export interface SendPodEmailParameter {
    orderNumber: string;
    isWillCallPod: boolean;
    emailTo: string;
    emailFrom: string;
    subject: string;
    message: string;
    onSuccess?: () => void;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<SendPodEmailParameter, SendPodEmailResult>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const CallSendPodEmailApi: HandlerType = async props => {
    const {
        orderNumber,
        isWillCallPod,
        emailTo,
        emailFrom,
        subject,
        message,
    } = props.apiParameter;

    const result = await sendPodEmailService({
        orderNumber,
        isWillCallPod,
        emailTo,
        emailFrom,
        subject,
        message,
    });

    if (!result.successful) {
        props.parameter.onError?.(result.message || "Failed to send POD email.");
        return false;
    }

    props.apiResult = {
        isSuccess: result.successful,
        message: result.message,
        data: result.data,
    };
};

export const RunOnSuccessCallback: HandlerType = props => {
    if (props.apiResult?.isSuccess && props.parameter?.onSuccess) {
        props.parameter.onSuccess();
    }
};

export const chain = [PopulateApiParameter, CallSendPodEmailApi, RunOnSuccessCallback];

const sendPodEmail = createHandlerChainRunner(chain, "SendPodEmail");
export default sendPodEmail;
